// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2D0tj","colCheckbox":"styles_colCheckbox__lXwxh"};